import { AxiosInstance } from 'axios'
import {
  DataExport,
  DataExportResponse,
  DataExportsParams,
  DataExportsResponse,
  ExportEntityParams
} from 'types/exports'
import { DATA_EXPORTS_ENDPOINTS } from 'api/ApiRoutes'
import moment from 'moment/moment'
import pickBy from 'lodash.pickby'
import { cleanOnboardingParams, formatDateParams } from 'utils/Functions'
import { DateRangeFilterInAPI } from 'types/reports'
import { MembersFilter, MembersTableColumnsKeys } from 'types/members'

class ExportsApi {
  constructor(private axiosInstance: AxiosInstance) {}

  exportData = async (params: Partial<ExportEntityParams>) => {
    const d = await this.axiosInstance.post<DataExportResponse>(
      DATA_EXPORTS_ENDPOINTS.BASE,
      params
    )
    return d.data
  }

  getDataExports = async ({
    view = 'personal'
  }: {
    view: 'personal' | 'team'
  }) => {
    const d = await this.axiosInstance.get(DATA_EXPORTS_ENDPOINTS.BASE)
    if (view === 'personal') {
      return d.data.exports.sort((a: DataExport, b: DataExport) =>
        moment(b.last_modified).diff(moment(a.last_modified))
      ) as DataExport[]
    }
    if (view === 'team') {
      return d.data.enterprise.sort((a_1: DataExport, b_2: DataExport) =>
        moment(b_2.last_modified).diff(moment(a_1.last_modified))
      ) as DataExport[]
    }
    return [] as DataExport[]
  }

  dataExport = async ({
    type,
    dataExport,
    columns,
    file_type
  }: DataExportsParams) => {
    const { date_range, ...rest } = dataExport ?? {}
    const payload = pickBy(
      {
        ...rest,
        ...formatDateParams<DateRangeFilterInAPI>(date_range)
      },
      (v) => {
        if (Array.isArray(v)) return v.length > 0
        return v && v !== undefined && v !== null
      }
    )
    const d = await this.axiosInstance.post<DataExportsResponse>(
      DATA_EXPORTS_ENDPOINTS.BASE,
      {
        type: type,
        data_export: payload,
        columns: columns,
        file_type: file_type
      }
    )
    return d.data
  }

  membersExport = async ({
    fetchParams,
    columns,
    file_type,
    filters
  }: {
    columns?: MembersTableColumnsKeys[]
    file_type?: 'excel' | 'csv'
    filters?: MembersFilter
    fetchParams?: {
      member_token_ids?: string
      onboarding?: boolean
      include_invites?: boolean
    }
  }) => {
    const d = await this.axiosInstance.post<DataExportsResponse>(
      DATA_EXPORTS_ENDPOINTS.BASE,
      {
        type: 'members',
        fetch_params: {
          ...fetchParams,
          ...(filters ? cleanOnboardingParams(filters) : {})
        },
        columns: columns,
        file_type: file_type
      }
    )
    return d.data
  }
}

export default ExportsApi
